import IconButton from '@mui/material/IconButton';
import { ReactComponent as SettingsIcon } from '../assets/icons/main/component-icon.svg';
import { useTheme } from '@mui/material';

interface SettingsButtonPropTypes {
  onClick: () => void;
  disabled?: boolean;
}

const Styles = {
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
};

const SettingsButton = ({ onClick, disabled }: SettingsButtonPropTypes) => {
  const theme :any = useTheme();
  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <SettingsIcon style={{ ...Styles.icon, opacity: disabled ? 0.5 : 1, color:theme.palette.custom.light }} />
    </IconButton>
  );
};

export default SettingsButton;
